import { core } from '@tauri-apps/api';

export const IS_TAURI = core.isTauri();
export const IS_FILE = window.location.protocol === 'file:';
export const IS_WEB = !IS_TAURI && !IS_FILE;

export type BuildPlatform = 'web' | 'tauri' | 'file';

function getBuildPlatform(): BuildPlatform {
  if (IS_TAURI) return 'tauri';
  if (IS_FILE) return 'file';
  return 'web';
}

export const BUILD_PLATFORM = getBuildPlatform();
